import React from "react";
import Header from "components/Header/Header";
import WhoAreWeSection from "components/WhoAreWeSection/WhoAreWeSection";
import Footer from "components/Footer/Footer";
import ContactUsSection from "components/ContactUsSection/ContactUsSection";
import StartYourPathSection from "components/StartYourPathSection/StartYourPathSection";

const WhoAreWePage = () => {
    return (
        <div className="overlay">
            <Header />
            <WhoAreWeSection />
            <StartYourPathSection/>
            <ContactUsSection />            
            <Footer />
        </div>
    );
};

export default WhoAreWePage;